export default __webpack_public_path__ + "static/media/Poppins-MediumItalic.89e040c6.ttf";